'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Radio_module = require('../styles/Radio.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Radio component.
 *
 * @component
 * @example
 * ```jsx
 * <Radio name="radio" value="default" label="Radio default" checked disabled />
 * ```
 */
const Radio = React__namespace.forwardRef((props, ref) => {
    const { name, value, checked, disabled, readOnly, className, children, onChange = reactUtils.noop, ...restProps } = props;
    const cx = reactUtils.useStyles(Radio_module.default);
    const classNames = cx(className, 'container', {
        checked,
        disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'read-only': readOnly,
    });
    const controlClassNames = cx('control', {
        checked,
        disabled,
    });
    return (React__namespace.createElement("label", { "data-qa": "Radio", className: classNames },
        React__namespace.createElement("input", { ref: ref, className: cx('input'), type: "radio", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, ...restProps }),
        React__namespace.createElement("div", { className: controlClassNames }, checked ? React__namespace.createElement(reactIcons.Check, { className: cx('icon') }) : null),
        children ? React__namespace.createElement("span", { className: cx('label') }, children) : null));
});
Radio.defaultProps = {
    checked: false,
};
Radio.displayName = 'Radio';

exports.Radio = Radio;
//# sourceMappingURL=Radio.js.map
